import { OptionType } from '@components/select/dist/types';

import { TI18n } from 'localization/types';

export const VAT_RATE_PERCENTAGES = [0, 5, 7, 12, 16, 20, 22] as const;

export function buildVatRateSelectOptions(i18n: TI18n): OptionType[] {
  const labels = i18n.vatRates.optionLabels;

  return VAT_RATE_PERCENTAGES.map(percent => {
    const entry = labels?.[String(percent) as keyof typeof labels];

    return {
      value: percent,
      label: entry?.label ?? `${percent}%`,
      description: entry?.countries ? `(${entry.countries})` : undefined,
    };
  });
}
